/* eslint-disable new-cap */
import { SchedulePostFormInputs } from './types'

export const CURRENT_TZ = Intl.DateTimeFormat().resolvedOptions()?.timeZone

export const INITIAL_FORM_DATA = {
  scheduledPubDate: '',
  scheduledPubTime: '',
  scheduledPubTimeZoneId: CURRENT_TZ ?? '',
  pubDate: ''
} as SchedulePostFormInputs

export const FORM_VALIDATION = {
  scheduledPubDate: {
    isValid: (value: string) => value?.trim().length > 0
  },
  scheduledPubTime: {
    isValid: (value: string) => value?.trim().length > 0
  },
  scheduledPubTimeZoneId: {
    isValid: (value: string) => value?.trim().length > 0
  },
  pubDate: {
    isValid: () => true
  },
} as Record<keyof SchedulePostFormInputs, Record<'isValid', (value: any) => boolean>>

export const SCHEDULE_POST_FORM_DATA_KEY = 'schedule-post-form-data-key'